import {system_setting_api} from '@/api/index.js'
import helper from '@/common/helper.js';
export default async ({i18n})=>{
  const res = await system_setting_api();
  if (res && res.data.code == 1) {
		const messages = helper.deepMerge(res.data.data.lang_list)
		for (let lang in messages) {
			i18n.mergeLocaleMessage(lang, messages[lang]);
		}
		if (res.data.data.lang && !helper.getLang()) {
			i18n.locale = res.data.data.lang.find(item => item.is_default === 1).lang;
			helper.setLang(res.data.data.lang.find(item => item.is_default === 1).lang);
			// helper.set('i18n_icon', res.data.data.lang.find(item => item.is_default === 1)?.lang);
		}
		helper.set('alllang', res.data.data.lang);
		helper.set('i18n_messages', messages);
		helper.set('rule', res.data.data);
  }
  
}